import { Injectable } from '@angular/core';
import { AvailabilityColor } from '../enums/availability-color.enum';
import { DateRangeCubeJs } from '../enums/cubejs/date-range';
import { GranularityCubeJs } from '../enums/cubejs/granularity';
import { GraphType } from '../enums/cubejs/graph-type';
import { MeasureKeyType } from '../enums/cubejs/measure-key.enum.ts';
import { DateRangeModel } from '../models/cubejs/DateRangeModel';
import { GranularityModel } from '../models/cubejs/granularityModel';

@Injectable({
    providedIn: 'root'
  })
  export class CubeJsService {

    readonly I18N_GRANULARITY_SECOND = 'granularity.second';
    readonly I18N_GRANULARITY_MINUTE = 'granularity.minute';
    readonly I18N_GRANULARITY_HOUR = 'granularity.hour';
    readonly I18N_GRANULARITY_DAY = 'granularity.day';
    readonly I18N_GRANULARITY_WEEK = 'granularity.week';
    readonly I18N_GRANULARITY_MONTH = 'granularity.month';
    readonly I18N_GRANULARITY_QUARTER = 'granularity.quarter';
    readonly I18N_GRANULARITY_YEAR = 'granularity.year';


    readonly I18N_DATE_RANGE_TODAY = 'timeGroup.today';
    readonly I18N_DATE_RANGE_YESTERDAY = 'timeGroup.yesterday';
    readonly I18N_DATE_RANGE_THIS_WEEK = 'timeGroup.thisWeek';
    readonly I18N_DATE_RANGE_THIS_MONTH = 'timeGroup.thisMonth';
    readonly I18N_DATE_RANGE_THIS_QUARTER = 'timeGroup.thisQuarter';
    readonly I18N_DATE_RANGE_THIS_YEAR = 'timeGroup.thisYear';
    readonly I18N_DATE_RANGE_LAST_7_DAYS = 'timeGroup.7days';
    readonly I18N_DATE_RANGE_LAST_30_DAYS = 'timeGroup.30days';
    readonly I18N_DATE_RANGE_LAST_WEEK = 'timeGroup.lastWeek';
    readonly I18N_DATE_RANGE_LAST_MONTH = 'timeGroup.lastMonth';
    readonly I18N_DATE_RANGE_LAST_QUARTER = 'timeGroup.lastQuarter';
    readonly I18N_DATE_RANGE_LAST_YEAR = 'timeGroup.lastYear';
    readonly I18N_DATE_RANGE_CUSTOM = 'timeGroup.custom';

    readonly DISPONIBILITE_AVAILABLE_PC_COLOR = AvailabilityColor.AVAILABLE;
    readonly DISPONIBILITE_PARTIALLY_PC_COLOR = AvailabilityColor.PARTIALLY_AVAILABLE;
    readonly DISPONIBILITE_UNVAILABLE_PC_COLOR = AvailabilityColor.UNAVAILABLE;
    readonly DISPONIBILITE_UNKNOWN_PC_COLOR = AvailabilityColor.UNKNOWN;
    readonly DISPONIBILITE_UNDEFINED_PC_COLOR = AvailabilityColor.UNDEFINED;

    readonly DISPONIBILITE_AVAILABLE_PC_COLOR_HOVER = AvailabilityColor.AVAILABLE_HOVER;
    readonly DISPONIBILITE_PARTIALLY_PC_COLOR_HOVER = AvailabilityColor.PARTIALLY_HOVER;
    readonly DISPONIBILITE_UNVAILABLE_PC_COLOR_HOVER = AvailabilityColor.UNAVAILABLE_HOVER;
    readonly DISPONIBILITE_UNKNOWN_PC_COLOR_HOVER = AvailabilityColor.UNKNOWN_HOVER;
    readonly DISPONIBILITE_UNDEFINED_PC_COLOR_HOVER = AvailabilityColor.UNDEFINED_HOVER;

    constructor() {

    }

    getGranularityList(blackList?: GranularityCubeJs[]): GranularityModel[] {
        const list: GranularityModel[] = [];
        Object.values(GranularityCubeJs).forEach(g => {
            if (!blackList || (blackList.length > 0 && !blackList.includes(g))) {
                list.push(this.getGranularity(g));
            }

        });
        return list;
    }

    getGranularity(value: GranularityCubeJs): GranularityModel {
        let name = '';

        switch (value) {
            case GranularityCubeJs.SECOND:
                name = this.I18N_GRANULARITY_SECOND;
                break;
            case GranularityCubeJs.MINUTE:
                name = this.I18N_GRANULARITY_MINUTE;
                break;
            case GranularityCubeJs.HOUR:
                name = this.I18N_GRANULARITY_HOUR;
                break;
            case GranularityCubeJs.DAY:
                name = this.I18N_GRANULARITY_DAY;
                break;
            case GranularityCubeJs.WEEK:
                name = this.I18N_GRANULARITY_WEEK;
                break;
            case GranularityCubeJs.MONTH:
                name = this.I18N_GRANULARITY_MONTH;
                break;
            case GranularityCubeJs.QUARTER:
                name = this.I18N_GRANULARITY_QUARTER;
                break;
            case GranularityCubeJs.YEAR:
                name = this.I18N_GRANULARITY_YEAR;
                break;
            default:
                console.error('Unknown granularity', value);
                break;
        }

        return new GranularityModel(name, value);
    }



    getDateRangeList(): DateRangeModel[] {
        const list: DateRangeModel[] = [];
        Object.values(DateRangeCubeJs).forEach(d => list.push(this.getDateRange(d)));
        return list;
    }

    getDateRange(value: DateRangeCubeJs): DateRangeModel {
        let name = '';

        switch (value) {
            case DateRangeCubeJs.TODAY:
                name = this.I18N_DATE_RANGE_TODAY;
                break;
            case DateRangeCubeJs.YESTERDAY:
                name = this.I18N_DATE_RANGE_YESTERDAY;
                break;
            case DateRangeCubeJs.THIS_WEEK:
                name = this.I18N_DATE_RANGE_THIS_WEEK;
                break;
            case DateRangeCubeJs.THIS_MONTH:
                name = this.I18N_DATE_RANGE_THIS_MONTH;
                break;
            case DateRangeCubeJs.THIS_YEAR:
                name = this.I18N_DATE_RANGE_THIS_YEAR;
                break;
            case DateRangeCubeJs.THIS_QUARTER:
                name = this.I18N_DATE_RANGE_THIS_QUARTER;
                break;
            case DateRangeCubeJs.LAST_7_DAYS:
                name = this.I18N_DATE_RANGE_LAST_7_DAYS;
                break;
            case DateRangeCubeJs.LAST_30_DAYS:
                name = this.I18N_DATE_RANGE_LAST_30_DAYS;
                break;
            case DateRangeCubeJs.LAST_WEEK:
                name = this.I18N_DATE_RANGE_LAST_WEEK;
                break;
            case DateRangeCubeJs.LAST_MONTH:
                name = this.I18N_DATE_RANGE_LAST_MONTH;
                break;
            case DateRangeCubeJs.LAST_QUARTER:
                    name = this.I18N_DATE_RANGE_LAST_QUARTER;
                        break;
            case DateRangeCubeJs.LAST_YEAR:
                name = this.I18N_DATE_RANGE_LAST_YEAR;
                break;
            case DateRangeCubeJs.CUSTOM:
                name = this.I18N_DATE_RANGE_CUSTOM;
                break;
            default:
                console.error('Unknown date range');
                break;
        }

        return new DateRangeModel(name, value);
    }

    getColoLabelByMeasureKey(measure: MeasureKeyType): string {
        let color = '';
        
        switch (measure.substring(measure.lastIndexOf('.') + 1)) {
            case MeasureKeyType.DISPONIBILITE_AVAILABLE_PC:
                color = this.DISPONIBILITE_AVAILABLE_PC_COLOR;
                break;
            case MeasureKeyType.DISPONIBILITE_PARTIALLY_PC:
                color = this.DISPONIBILITE_PARTIALLY_PC_COLOR;
                break;
            case MeasureKeyType.DISPONIBILITE_UNKNOWN_PC:
                color = this.DISPONIBILITE_UNKNOWN_PC_COLOR;
                break;
            case MeasureKeyType.DISPONIBILITE_UNVAILABLE_PC:
                color = this.DISPONIBILITE_UNVAILABLE_PC_COLOR;
                break;
            default:
                color = this.DISPONIBILITE_UNDEFINED_PC_COLOR;
                break;
        }
        
        return color;
    }

    getColoHoverLabelByMeasureKey(measure: MeasureKeyType): string {
        let color = '';

        switch (measure.substring(measure.lastIndexOf('.') + 1)) {
            case MeasureKeyType.DISPONIBILITE_AVAILABLE_PC:
                color = this.DISPONIBILITE_AVAILABLE_PC_COLOR_HOVER;
                break;
            case MeasureKeyType.DISPONIBILITE_PARTIALLY_PC:
                color = this.DISPONIBILITE_PARTIALLY_PC_COLOR_HOVER;
                break;
            case MeasureKeyType.DISPONIBILITE_UNKNOWN_PC:
                color = this.DISPONIBILITE_UNKNOWN_PC_COLOR_HOVER;
                break;
            case MeasureKeyType.DISPONIBILITE_UNVAILABLE_PC:
                color = this.DISPONIBILITE_UNVAILABLE_PC_COLOR_HOVER;
                break;
            default:
                color = this.DISPONIBILITE_UNDEFINED_PC_COLOR_HOVER;
                break;
        }

        return color;
    }

    getColorLabelByGraphType(graphType: GraphType, measure: MeasureKeyType): string {
        switch (graphType) {
            case GraphType.STATION_AVAILABILITY:
                return this.getColoLabelByMeasureKey(measure);
            case GraphType.STATION_ALARM:
            default:
                break;
        }
    }

    getHoverColorLabelByGraphType(graphType: GraphType, measure: MeasureKeyType): string {
        switch (graphType) {
            case GraphType.STATION_AVAILABILITY:
                return this.getColoHoverLabelByMeasureKey(measure);
            case GraphType.STATION_ALARM:
            default:
                break;
        }
    }

    hasDefinedColors(graphType: GraphType): boolean {
        switch (graphType) {
            case GraphType.STATION_AVAILABILITY:
                return true;
            case GraphType.STATION_ALARM:
                return false;
            default:
                break;
        }
    }

    hasDefinedHoverColors(graphType: GraphType): boolean {
        switch (graphType) {
            case GraphType.STATION_AVAILABILITY:
                return true;
            case GraphType.STATION_ALARM:
                return false;
            default:
                break;
        }
    }
  }
